import React from 'react';

class CartItem extends React.Component {
	constructor() {
		super();

		this.state = {
			price: null
		};

		this.increment = this.increment.bind(this);
		this.decrement = this.decrement.bind(this);
		this.removeFromCart = this.removeFromCart.bind(this);
	}

	removeFromCart() {
		this.props.cart.removeLineItem(this.props.item.id)
			.then((newCart) => {
				this.props.updateCart(newCart);
			})
			.catch((err) => {
				// TODO - display error
				this.error = "Sorry, there was a problem removing this item from your cart. Try again?";
				console.error(`There was a problem removing this item from the cart. ${err}`);
			});
	}

	increment() {
		let newQuantity = ++this.props.item.quantity;
		this.updateQuantity(newQuantity);
	}

	decrement() {
		let newQuantity = --this.props.item.quantity;
		this.updateQuantity(newQuantity);
	}

	updateQuantity(quantity) {
		this.props.cart.updateLineItem(this.props.item.id, quantity)
			.then((newCart) => {
				this.props.updateCart(newCart);
			})
			.catch((err) => {
				this.error = "Sorry, there was a problem updating the quantity. Try again?";
				console.error(`There was a problem updating the quantity for this item. ${err}`);
			});
	}

	componentWillReceiveProps() {
		if (!this.props.item) {
			return null;
		}

		let price = "$" + Math.round(Number(this.props.item.line_price));

		this.setState({
			price: price
		});
	}

	render() {
		let item = this.props.item;

		return (
			<div className="cart__item">
				<div className="item__image">
					<img src={item.image.src} alt={item.title} />
				</div>
				<div className="item__details">
					<div className="item__details__title-and-price">
						<span className="title">{item.title}</span>
						{this.state.price}
					</div>
					<div className="item__details__quantity">
						<a className="cart__link cart__link--qty" onClick={this.decrement}>–</a>
						<div className="qty">{item.quantity}</div>
						<a className="cart__link cart__link--qty" onClick={this.increment}>+</a>

						<a className="cart__link cart__link--remove-from-cart" onClick={this.removeFromCart}>Remove</a>
					</div>
				</div>
			</div>
		);
	}
}

export default CartItem;



// WEBPACK FOOTER //
// ./src/components/Site/Shop/CartItem.js